var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page",staticStyle:{"overflow-x":"hidden"}},[_c('loginCard_desktop',{ref:"signIn",staticClass:"login-card",attrs:{"isSignIn":true,"type":_vm.$route.query.device},on:{"loginSuccess":_vm.loginSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }